const A = "/assets";

export const RESULT_VIDEOS = [
  { id: "video-1", src: `${A}/results-video-1.mp4`, poster: `${A}/results-video-1-poster.jpg`, w: 640, h: 1134, caption: "$58,000 business line of credit offer" },
  { id: "video-2", src: `${A}/results-video-2.mp4`, poster: `${A}/results-video-2-poster.jpg`, w: 540, h: 960, caption: "$95,000 business credit line — offer accepted" },
];

const SHOTS = [
  [900, 1302, "My own funding: a $128,301.56 Navy Federal cashier’s check"],
  [900, 533, "$90,000 business credit line — same day"],
  [900, 646, "+92 · +181 · +184 points, with 36 items deleted"],
  [590, 930, "$79,000 business credit line offer"],
  [900, 518, "Experian +85 since starting · 29 items deleted · TransUnion 809"],
  [665, 1340, "$35,000 business line of credit — offer accepted"],
  [900, 1422, "765 · 753 — “all the negatives gone on the third one too?”"],
  [900, 539, "Experian +161 · TransUnion +164 · 39 items deleted"],
  [900, 1200, "Two Navy Federal Flagship cards in hand"],
  [613, 707, "In a client’s own words"],
  [900, 1458, "$41,000 Navy Federal Flagship Rewards limit"],
  [900, 736, "+125 · +88 · +72 — all three scores above 720"],
  [900, 876, "$30,000 business credit line offer"],
  [900, 648, "45 negative items deleted across all three bureaus"],
  [900, 1561, "$20,000 Navy Federal Visa Signature approval"],
  [560, 703, "$20,000 credit union loan approval"],
  [715, 1432, "TransUnion 782 — up 61 points"],
  [1200, 465, "Charge-offs and collections deleted from all three bureaus"],
  [556, 710, "756 · 771 · 759 — and a thank-you from the client"],
];

export const RESULT_SHOTS = SHOTS.map(([w, h, caption], i) => {
  const n = String(i + 1).padStart(2, "0");
  return { id: `result-${n}`, src: `${A}/result-${n}.jpg`, w, h, caption };
});

export const INITIAL_SHOTS = 8;
